export default __webpack_public_path__ + "static/media/file_copy.03d7443d.svg";